/*
  UPUPA – päiväkohtainen tilaaminen (D-0038, 25.9.2026)

  Jokainen ostoskorin rivi saa oman toimituspäivän (rivin ominaisuudet "Toimituspäivä" = "ti 6.10.2026"
  ja piilotettu "_pvm" = "2026-10-06"). Samassa ostoskorissa voi olla useita päiviä, ja jokaiselle
  päivälle valitaan oma tunnin toimitusaika (ostoskorin attribuutti "Toimitusaika 2026-10-06").

  1. Yhteiset: menudata (snippets/upupa-menu-data.liquid), Helsingin aika, tilausikkuna, annoksen päivät.
  2. Päivävalitsin ja päivän menu (sections/upupa-paivavalitsin.liquid).
  2b. Ruokalista: valitse ensin ruoka ja näe, minä päivinä se on menulla (sections/upupa-ruoat.liquid);
      ruokaryhmät välilehtinä (D-0046). "Takaisin"-painike: snippets/upupa-takaisin.liquid.
  2c. Etusivun "Viikon pääruoat": kaksi seuraavaa tilattavaa pääruokaa (sections/upupa-viikon-paaruoat.liquid, D-0049).
  3. Tuotesivun toimituspäivä (blocks/upupa-toimituspaiva.liquid).
  3b. Tuotesivun "Menulla"-merkki (blocks/upupa-menulla.liquid) ja "Samana päivänä menulla"
      (sections/upupa-samana-paivana.liquid), D-0049. Lisäksi korttien kuvanvaihto ja "Ylös"-painike.
  4. Ostoskori: toimitusajat, puuttuvien päivien korjaus ja kassan esto (snippets/upupa-toimitusaika.liquid).

  Ei ulkoisia kirjastoja. Tiedot tallentuvat vain Shopifyn omaan ostoskoriin; selaimeen jää korkeintaan
  viimeksi valittu päivä (sessionStorage "upupa_pvm"), jotta tuotesivu osaa ehdottaa samaa päivää.
*/
(function () {
  'use strict';
  if (typeof window === 'undefined' || window.UPUPA_TILAUS) return;

  var DAY = 86400000;
  var ISO_RE = /^\d{4}-\d{2}-\d{2}$/;
  var WD_LONG = ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai'];
  var WD_SHORT = ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'];
  var MONTHS = ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu',
    'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'];
  var DEFAULT_SLOTS = ["10:00–11:00","11:00–12:00","12:00–13:00","13:00–14:00","14:00–15:00","18:00–19:00"];
  var DEFAULT_WEEKEND = ["10:00–11:00","11:00–12:00","12:00–13:00","13:00–14:00","14:00–15:00","18:00–19:00"];
  var ATTR_PREFIX = 'Toimitusaika ';
  var LEGACY_ATTRS = ['Toimituspäivä', 'Toimitusaika'];
  var STORE_KEY = 'upupa_pvm';
  var PDP_VISIBLE = 14;
  var clock = function () { return new Date(); };

  /* ---------- 1. Yhteiset ---------- */

  var DATA;
  function data() {
    if (DATA !== undefined) return DATA;
    DATA = null;
    var el = typeof document !== 'undefined' ? document.getElementById('upupa-menu-data') : null;
    if (el) {
      try { DATA = JSON.parse(el.textContent); } catch (e) { DATA = null; }
    }
    return DATA;
  }

  var I18N = (data() || {}).i18n || {};
  function tr(key, values) {
    var text = I18N[key] || '';
    Object.keys(values || {}).forEach(function (name) {
      text = text.split('{{ ' + name + ' }}').join(String(values[name]));
    });
    return text;
  }
  // The hidden _pvm remains the canonical date; customer-facing labels follow the active language.
  if (I18N.weekdays_long) WD_LONG = I18N.weekdays_long.split('|');
  if (I18N.weekdays_short) WD_SHORT = I18N.weekdays_short.split('|');
  if (I18N.months) MONTHS = I18N.months.split('|');

  function isoToUtc(s) { var a = String(s).split('-'); return Date.UTC(+a[0], +a[1] - 1, +a[2]); }
  function utcToIso(u) { return new Date(u).toISOString().slice(0, 10); }
  function dow(u) { return new Date(u).getUTCDay(); }
  function isWeekend(u) { var d = dow(u); return d === 0 || d === 6; }
  function dm(u) { var d = new Date(u); return d.getUTCDate() + '.' + (d.getUTCMonth() + 1) + '.'; }
  function longLabel(u) { return WD_LONG[dow(u)] + ' ' + dm(u) + new Date(u).getUTCFullYear(); }
  function propLabel(u) { return WD_SHORT[dow(u)] + ' ' + dm(u) + new Date(u).getUTCFullYear(); }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  function helsinkiNow() {
    var o = {};
    try {
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Helsinki', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', hour12: false
      }).formatToParts(clock()).forEach(function (p) { o[p.type] = p.value; });
    } catch (e) { o = {}; }
    if (!o.year) {
      var n = clock();
      return { today: Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()), hour: n.getHours() };
    }
    return { today: Date.UTC(+o.year, +o.month - 1, +o.day), hour: (parseInt(o.hour, 10) || 0) % 24 };
  }

  // Tilattavat päivät: klo 16 mennessä seuraavaksi päiväksi, ei ennen avauspäivää, horizonDays eteenpäin.
  function orderWindow() {
    var D = data() || {};
    var now = helsinkiNow();
    var cutoff = typeof D.cutoffHour === 'number' ? D.cutoffHour : 16;
    var open = isoToUtc(D.open || D.anchor || '2026-11-01');
    var before = now.hour < cutoff;
    var byCutoff = now.today + (before ? 1 : 2) * DAY;
    var first = Math.max(byCutoff, open);
    var last = first + ((D.horizonDays || 84) - 1) * DAY;
    var skippedWeekend = isWeekend(first);
    while (isWeekend(first)) first += DAY;
    return {
      first: first,
      last: last,
      skippedWeekend: skippedWeekend,
      beforeCutoff: before,
      notOpenYet: byCutoff < open
    };
  }

  // 'always' = mille tahansa arkipäivälle, 'menu' = vain kiertopäivinä, 'none' = ei menulla.
  function kindOf(handle) {
    var D = data();
    if (!D || !handle) return 'always';
    if ((D.always || []).indexOf(handle) > -1) return 'always';
    if ((D.h || []).indexOf(handle) > -1) return 'menu';
    return 'none';
  }

  function menuHandles(u) {
    if (isWeekend(u)) return [];
    var D = data();
    if (!D || !D.days || !D.days.length || !D.h) return [];
    var n = D.cycle || D.days.length;
    var diff = Math.round((u - isoToUtc(D.anchor || D.open)) / DAY);
    var row = D.days[((diff % n) + n) % n] || [];
    return row.map(function (i) { return D.h[i]; });
  }

  function availableOn(handle, u) {
    if (isWeekend(u)) return false;
    var k = kindOf(handle);
    if (k === 'always') return true;
    if (k === 'none') return false;
    return menuHandles(u).indexOf(handle) > -1;
  }

  function availableDates(handle, w) {
    w = w || orderWindow();
    var out = [];
    if (kindOf(handle) === 'none') return out;
    for (var u = w.first; u <= w.last; u += DAY) {
      if (availableOn(handle, u)) out.push(u);
    }
    return out;
  }

  // '' = kunnossa, muuten syy: missing | past | far | offmenu | weekend
  function dateProblem(handle, iso, w) {
    if (!iso || !ISO_RE.test(iso) || utcToIso(isoToUtc(iso)) !== iso) return 'missing';
    w = w || orderWindow();
    var u = isoToUtc(iso);
    if (u < w.first) return 'past';
    if (u > w.last) return 'far';
    if (isWeekend(u)) return 'weekend';
    if (!availableOn(handle, u)) return 'offmenu';
    return '';
  }

  function partyWindow() {
    var D = data() || {};
    return { first: Math.max(helsinkiNow().today + 5 * DAY, isoToUtc(D.open || D.anchor || '2026-11-01')) };
  }
  function partyDateProblem(iso) {
    if (!iso || !ISO_RE.test(iso) || utcToIso(isoToUtc(iso)) !== iso) return 'missing';
    return isoToUtc(iso) < partyWindow().first ? 'week' : '';
  }
  function celebrationDateProblem(iso, handle) {
    return partyDateProblem(iso) || (handle === 'pikkujoulumenu' && iso > '2026-12-31' ? 'offmenu' : '');
  }
  function partyItem(it) { return !!(it.properties && it.properties._upupa_order === 'juhla'); }
  function partySubtotal(items) {
    return (items || []).filter(partyItem).reduce(function (sum, it) {
      var amount = Number(it.final_line_price == null ? it.line_price : it.final_line_price);
      return sum + (Number.isSafeInteger(amount) && amount > 0 ? amount : 0);
    }, 0);
  }
  // Shopify enforces the same 20 EUR qualifying subtotal before the benefit.
  function partyOriginalSubtotal(items) {
    return (items || []).filter(partyItem).reduce(function (sum, it) {
      var amount = Number(it.original_line_price == null ? it.line_price : it.original_line_price);
      return sum + (Number.isSafeInteger(amount) && amount > 0 ? amount : 0);
    }, 0);
  }
  function pikkujouluBenefitWanted(cart) {
    var config = (data() || {}).pikkujouluBenefit;
    if (!config || clock().getTime() > Date.parse(config.endsAt)) return false;
    return (cart.items || []).some(function (it) {
      var iso = (it.properties || {})._pvm;
      return partyItem(it) && iso >= '2026-11-16' && iso <= '2026-12-31' && !partyDateProblem(iso);
    });
  }
  function pikkujouluQualifyingSubtotal(cart) {
    var ids = ((data() || {}).pikkujouluBenefit || {}).productIds || [];
    return (cart.items || []).reduce(function (sum, it) {
      if (ids.indexOf(Number(it.product_id)) < 0) return sum;
      return sum + Number(it.original_line_price == null ? it.line_price || 0 : it.original_line_price);
    }, 0);
  }
  function benefitCodes(cart) {
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application.type === 'discount_code') codes.push(a.discount_application.title);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (a.type === 'discount_code') codes.push(a.title);
    });
    return codes.filter(function (code, index) { return code && codes.indexOf(code) === index; });
  }
  function syncPikkujouluBenefit(cart) {
    return (cart ? Promise.resolve(cart) : getCart()).then(function (current) {
      var config = (data() || {}).pikkujouluBenefit;
      if (!config) return current;
      var wanted = pikkujouluBenefitWanted(current);
      var existing = benefitCodes(current);
      var codes = existing.filter(function (code) { return code.toUpperCase() !== config.code; });
      if (wanted) codes.push(config.code);
      if (codes.join(',') === existing.join(',')) return current;
      return postJSON('cart/update.js', { discount: codes.join(',') });
    });
  }
  function partyMessage(problem) {
    return problem === 'minimum' ? tr('party_minimum') : '';
  }

  function slotsFor(iso) {
    var D = data() || {};
    return isWeekend(isoToUtc(iso)) ? (D.weekendSlots || DEFAULT_WEEKEND) : (D.slots || DEFAULT_SLOTS);
  }

  // Peräkkäiset päivät jaksoiksi: "su 11.10.–ke 14.10. · to 10.12.–ke 16.12."
  function formatRanges(dates, max) {
    var ranges = [];
    var s = dates[0];
    var p = dates[0];
    for (var i = 1; i <= dates.length; i++) {
      var u = dates[i];
      if (u === p + DAY) { p = u; continue; }
      ranges.push([s, p]);
      s = u;
      p = u;
    }
    var one = function (u) { return WD_SHORT[dow(u)] + ' ' + dm(u); };
    var out = ranges.slice(0, max || 2).map(function (r) {
      return r[0] === r[1] ? one(r[0]) : one(r[0]) + '–' + one(r[1]);
    }).join(' · ');
    return ranges.length > (max || 2) ? out + tr('and_later') : out;
  }

  // Ruokalistan kortin teksti: minä päivinä ruoka on tilattavissa.
  function availabilityText(handle, w) {
    var k = kindOf(handle);
    if (k === 'always') return tr('every_day');
    var dates = availableDates(handle, w);
    return dates.length ? tr('on_menu') + formatRanges(dates) : tr('not_on_menu');
  }

  // Tarkistaa koko ostoskorin (/cart.js): jokaisella rivillä kelvollinen päivä, jokaisella päivällä aika.
  function mealPackageSlot(iso) {
    var D = data();
    if (!D || !ISO_RE.test(iso || '')) return -1;
    var n = D.cycle || D.days.length;
    var diff = Math.round((isoToUtc(iso) - isoToUtc(D.anchor || D.open)) / DAY);
    var index = ((diff % n) + n) % n;
    return Math.floor(index / 7) * 2 + (index % 7 < 3 ? 0 : 1);
  }

  function mealPackageProblem(handle, iso, slot, w) {
    var problem = dateProblem(handle, iso, w);
    if (problem) return problem;
    if (handle !== 'lounaspaketti-yhdelle' && handle !== 'xxl-perhepaketti') return null;
    return slot !== null && slot !== undefined && String(slot) !== '' && Number(slot) === mealPackageSlot(iso) ? null : 'offmenu';
  }


  function staffData() {
    var source = document.getElementById('upupa-staff-data');
    try { return source ? JSON.parse(source.textContent) : null; } catch (e) { return null; }
  }
  function staffPackageProblem(item, iso, w) {
    var staff = staffData();
    var variant = staff && (staff.variants || []).find(function (v) { return String(v.id) === String(item.variant_id || item.id); });
    if (!variant || !variant.available) return 'offmenu';
    var ids = variant.sku.split('-').slice(2);
    var main = staff.components[ids[0]];
    var soup = ids[1] === '0' ? null : staff.components[ids[1]];
    if (!main || !main.available || (ids[1] !== '0' && (!soup || !soup.available))) return 'offmenu';
    if (variant.price !== Math.round((main.price + (soup ? soup.price : 0)) * .8)) return 'offmenu';
    var coffeeId = item.properties && item.properties._upupa_coffee_variant;
    var coffee = (staff.coffee || []).find(function (v) { return String(v.id) === String(coffeeId) && v.title.indexOf('250 ml') > -1; });
    if (!coffee || !coffee.available) return 'offmenu';
    return dateProblem(main.handle, iso, w) || (soup ? dateProblem(soup.handle, iso, w) : '');
  }

  function mealOfferData() {
    var source = document.getElementById('upupa-make-meal-data');
    try { return source ? JSON.parse(source.textContent) : null; } catch (e) { return null; }
  }
  function mealOfferProblem(item, iso, w) {
    var offer = mealOfferData();
    var variant = offer && (offer.variants || []).find(function(v) { return String(v.id) === String(item.variant_id || item.id); });
    if (!variant || !variant.available) return 'offmenu';
    var match = /^UPUPA-MEAL-(\d+)-(coffee|salad|complete)-([01])$/.exec(variant.sku);
    if (!match) return 'offmenu';
    var entries = (offer.products || []).reduce(function(out,p) { return out.concat(p.variants.map(function(v) { return { product:p, variant:v }; })); },[]);
    var main = entries.find(function(e) { return e.product.group === 'main' && String(e.variant.id) === match[1]; });
    var props = item.properties || {};
    var salad = match[2] === 'coffee' ? null : entries.find(function(e) { return e.product.group === 'salad' && e.variant.available; });
    var dessert = match[2] !== 'complete' ? null : entries.find(function(e) { return e.product.group === 'dessert' && String(e.variant.id) === String(props._upupa_meal_dessert); });
    var coffee = match[3] === '0' ? null : entries.find(function(e) { return e.product.group === 'coffee' && e.variant.title.indexOf('250 ml') > -1 && String(e.variant.id) === String(props._upupa_coffee_variant); });
    if (!main || (match[2] !== 'coffee' && !salad) || (match[2] === 'complete' && !dessert) || (match[3] === '1' && !coffee)) return 'offmenu';
    if (match[3] === '0' && props._upupa_coffee_variant || match[2] !== 'complete' && props._upupa_meal_dessert) return 'offmenu';
    var expected = main.variant.price + ({coffee:0,salad:290,complete:690})[match[2]] + Number(match[3])*170;
    if (variant.price !== expected) return 'offmenu';
    var chosen = [main,salad,dessert,coffee].filter(Boolean);
    for (var i=0;i<chosen.length;i++) {
      if (!chosen[i].variant.available) return 'offmenu';
      var problem = dateProblem(chosen[i].product.handle,iso,w);
      if (problem) return problem;
    }
    return '';
  }

  function auditCart(cart, w) {
    w = w || orderWindow();
    var items = (cart && cart.items) || [];
    var attrs = (cart && cart.attributes) || {};
    var byDate = {};
    var itemProblems = [];
    var missingTime = [];
    var cleanup = {};
    items.forEach(function (it) {
      var iso = it.properties && it.properties._pvm;
      var p = it.handle === 'make-it-a-meal' ? mealOfferProblem(it, iso, w) : it.handle === 'henkilostoateria' ? staffPackageProblem(it, iso, w) : partyItem(it) ? celebrationDateProblem(iso, it.handle) : mealPackageProblem(it.handle, iso, (it.properties || {})._upupa_package_slot, w);
      if (p) itemProblems.push({ key: it.key, handle: it.handle, iso: iso || '', type: p });
      if (iso && ISO_RE.test(iso)) (byDate[iso] = byDate[iso] || []).push(it.key);
    });
    var dates = Object.keys(byDate).sort();
    dates.forEach(function (iso) {
      var t = attrs[ATTR_PREFIX + iso];
      if (!t || slotsFor(iso).indexOf(t) < 0) missingTime.push(iso);
    });
    Object.keys(attrs).forEach(function (k) {
      if (!attrs[k]) return;
      if (LEGACY_ATTRS.indexOf(k) > -1) cleanup[k] = '';
      else if (k.indexOf(ATTR_PREFIX) === 0 && !byDate[k.slice(ATTR_PREFIX.length)]) cleanup[k] = '';
    });
    var partyTotal = pikkujouluBenefitWanted(cart) ? pikkujouluQualifyingSubtotal(cart) : partyOriginalSubtotal(items);
    var partyProblem = items.some(partyItem) && partyTotal < 2000 ? 'minimum' : '';
    return {
      ok: items.length > 0 && !itemProblems.length && !missingTime.length && !partyProblem,
      partyProblem: partyProblem,
      partySubtotal: partyTotal,
      dates: dates,
      itemProblems: itemProblems,
      missingTime: missingTime,
      cleanup: cleanup
    };
  }

  function rememberDate(iso) { try { window.sessionStorage.setItem(STORE_KEY, iso); } catch (e) {} }
  function recalledDate() {
    var v = null;
    try { v = new URLSearchParams(window.location.search).get('pvm'); } catch (e) { v = null; }
    if (v && ISO_RE.test(v)) return v;
    try { v = window.sessionStorage.getItem(STORE_KEY); } catch (e) { v = null; }
    return v && ISO_RE.test(v) ? v : null;
  }

  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function show(el, on) { if (el && el.hidden === !!on) el.hidden = !on; }
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function cssEsc(s) {
    return window.CSS && window.CSS.escape ? window.CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&');
  }
  function routeRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }
  function postJSON(path, body) {
    return fetch(routeRoot() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function getCart() {
    return fetch(routeRoot() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function withDate(href, iso) {
    try {
      var u = new URL(href, window.location.origin);
      u.searchParams.set('pvm', iso);
      return u.pathname + u.search + u.hash;
    } catch (e) { return href; }
  }

  // Kortin toimituspäivä: piilokentät, rivin nimi ja tuotelinkin ?pvm= (kalenteri ja "Samana päivänä menulla").
  function fillCardDate(card, u) {
    var iso = utcToIso(u);
    var a = card.querySelector('[data-upupa-iso]');
    if (a) a.value = iso;
    var l = card.querySelector('[data-upupa-label]');
    if (l) l.value = propLabel(u);
    var link = card.querySelector('a[data-upupa-link]');
    if (link) link.setAttribute('href', withDate(link.getAttribute('href'), iso));
    return card;
  }

  // Ensimmäinen yhtenäinen päiväjakso [alku, loppu] tai null; teksti "ke 7.10.–la 10.10.".
  function firstRun(dates) {
    if (!dates || !dates.length) return null;
    var s = dates[0];
    var e = dates[0];
    for (var i = 1; i < dates.length && dates[i] === e + DAY; i++) e = dates[i];
    return [s, e];
  }
  function runText(r) {
    var one = function (u) { return WD_SHORT[dow(u)] + ' ' + dm(u); };
    return r[0] === r[1] ? one(r[0]) : one(r[0]) + '–' + one(r[1]);
  }

  // Seuraavat pääruoat tilausikkunassa järjestyksessä: [{ h, from, to }], enintään count kappaletta.
  function nextMains(w, count) {
    w = w || orderWindow();
    var runs = [];
    for (var u = w.first; u <= w.last; u += DAY) {
      var h = menuHandles(u)[0];
      if (!h) continue;
      var last = runs[runs.length - 1];
      if (last && last.h === h && last.to + DAY === u) { last.to = u; continue; }
      if (runs.length === count) break;
      runs.push({ h: h, from: u, to: u });
    }
    return runs;
  }

  window.UPUPA_TILAUS = {
    version: '2026-09-25e',
    data: data,
    orderWindow: orderWindow,
    kindOf: kindOf,
    menuHandles: menuHandles,
    availableDates: availableDates,
    availabilityText: availabilityText,
    dateProblem: dateProblem,
    slotsFor: slotsFor,
    partyWindow: partyWindow,
    partyDateProblem: partyDateProblem,
    partySubtotal: partySubtotal,
    partyOriginalSubtotal: partyOriginalSubtotal,
    pikkujouluBenefitWanted: pikkujouluBenefitWanted,
    pikkujouluQualifyingSubtotal: pikkujouluQualifyingSubtotal,
    syncPikkujouluBenefit: syncPikkujouluBenefit,
    auditCart: auditCart,
    mealOfferData: mealOfferData,
    mealOfferProblem: mealOfferProblem,
    staffData: staffData,
    staffPackageProblem: staffPackageProblem,
    isoToUtc: isoToUtc,
    utcToIso: utcToIso,
    propLabel: propLabel,
    longLabel: longLabel,
    firstRun: firstRun,
    runText: runText,
    nextMains: nextMains,
    _setClock: function (f) { clock = f; }
  };

  if (typeof document === 'undefined' || !document.addEventListener) return;

  /* ---------- 2. Päivävalitsin ja päivän menu ---------- */

  function initCalendar(rootEl) {
    rootEl.setAttribute('data-upupa-ready', '');
    var $ = function (n) { return rootEl.querySelector('[data-el="' + n + '"]'); };
    var els = {
      note: $('note'), days: $('days'), month: $('month'), prev: $('prev'), next: $('next'),
      quick: $('quick'), legend: $('legend'), head: $('chosen-h'), sub: $('chosen-s'), msg: $('msg'),
      menu: $('menu'), extras: $('extras'), pool: $('pool'), summary: $('date-summary')
    };
    if (!els.days || !els.menu) return;
    var D = data() || {};
    var groups = D.groups || [];
    var pool = {};
    each(els.pool ? els.pool.querySelectorAll('.upupa-card') : [], function (c) {
      var h = c.getAttribute('data-handle');
      if (h && !pool[h]) pool[h] = c;
    });
    var w, selected, viewY, viewMo;
    var quickOrder = rootEl.hasAttribute('data-quick-order');
    var dateSwitch = rootEl.querySelector('[data-date-switch]');
    var categoryBrowser = rootEl.querySelector('[data-category-browser]');
    var categoryNav = categoryBrowser && categoryBrowser.querySelector('[data-category-buttons]');
    var categoryPanels = categoryBrowser && categoryBrowser.querySelector('[data-category-panels]');
    var categoryEntries = [];
    var activeCategory = '';
    var categoryKeys = ['main', 'soups', 'light', 'light', 'desserts', 'desserts'];

    function cloneCalendarCard(card, u, suffix) {
      var clone = card.cloneNode(true);
      var ids = Object.create(null);
      each(clone.querySelectorAll('[id]'), function (el) {
        var oldId = el.getAttribute('id');
        var newId = oldId + '-' + suffix;
        el.setAttribute('id', newId);
        ids[oldId] = newId;
      });
      each(clone.querySelectorAll('[for], [form], [aria-labelledby], [aria-describedby]'), function (el) {
        ['for', 'form', 'aria-labelledby', 'aria-describedby'].forEach(function (attr) {
          var value = el.getAttribute(attr);
          if (value) el.setAttribute(attr, value.split(/\s+/).map(function (id) { return ids[id] || id; }).join(' '));
        });
      });
      return dateCard(clone, u);
    }

    function selectCategory(key, reveal) {
      activeCategory = key;
      categoryEntries.forEach(function (entry) {
        var on = entry.key === key;
        entry.button.setAttribute('aria-expanded', on ? 'true' : 'false');
        show(entry.panel, on);
      });
      if (key && reveal && categoryBrowser) {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        categoryBrowser.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    }

    function renderCategories(buckets, u) {
      if (!categoryNav || !categoryPanels) return;
      var entries = buckets.filter(function (bk) { return bk.key !== 'main'; });
      [{ key: 'salads', source: 'salaatit' }, { key: 'sides', source: 'lisukkeet' }, { key: 'cold-drinks', source: 'kylmat-juomat' }, { key: 'warm-drinks', source: 'lampimat-juomat' }].forEach(function (extra) {
        var group = els.extras && els.extras.querySelector('[data-extra-category="' + extra.source + '"]');
        var cards = group && Array.prototype.slice.call(group.querySelectorAll('.upupa-card'));
        if (cards && cards.length) entries.push({ key: extra.key, cards: cards });
      });
      categoryNav.innerHTML = '';
      categoryPanels.innerHTML = '';
      categoryEntries = [];
      var prefix = categoryBrowser.getAttribute('data-category-id');
      entries.forEach(function (bk) {
        var label = categoryBrowser.getAttribute('data-' + bk.key) || bk.label;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'upupa-category-button';
        button.id = prefix + '-button-' + bk.key;
        button.textContent = label;
        button.setAttribute('data-category', bk.key);
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', prefix + '-panel-' + bk.key);
        var panel = document.createElement('div');
        panel.className = 'upupa-category-panel';
        panel.id = prefix + '-panel-' + bk.key;
        panel.hidden = true;
        panel.tabIndex = 0;
        panel.setAttribute('role', 'region');
        panel.setAttribute('aria-labelledby', button.id);
        var grid = document.createElement('div');
        grid.className = 'upupa-grid';
        bk.cards.forEach(function (card) { grid.appendChild(cloneCalendarCard(card, u, 'category-' + bk.key)); });
        panel.appendChild(grid);
        categoryNav.appendChild(button);
        categoryPanels.appendChild(panel);
        categoryEntries.push({ key: bk.key, button: button, panel: panel });
      });
      var keep = categoryEntries.some(function (entry) { return entry.key === activeCategory; });
      selectCategory(keep ? activeCategory : '', false);
      show(categoryBrowser, !!categoryEntries.length);
    }

    if (categoryNav) {
      categoryNav.addEventListener('click', function (e) {
        var button = e.target.closest && e.target.closest('button[data-category]');
        if (!button || !categoryNav.contains(button)) return;
        var key = button.getAttribute('data-category');
        selectCategory(activeCategory === key ? '' : key, true);
      });
      categoryNav.addEventListener('keydown', function (e) {
        var button = e.target.closest && e.target.closest('button[data-category]');
        if (!button) return;
        if (e.key === 'Escape') { selectCategory('', false); return; }
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) === -1) return;
        e.preventDefault();
        var i = categoryEntries.findIndex(function (entry) { return entry.button === button; });
        if (e.key === 'Home') i = 0;
        else if (e.key === 'End') i = categoryEntries.length - 1;
        else i = (i + (e.key === 'ArrowRight' ? 1 : -1) + categoryEntries.length) % categoryEntries.length;
        categoryEntries[i].button.focus({ preventScroll: true });
        categoryEntries[i].button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }

    function setup() {
      w = orderWindow();
      selected = w.first;
      var rec = recalledDate();
      if (rec) {
        var ru = isoToUtc(rec);
        if (ru >= w.first && ru <= w.last && !isWeekend(ru)) selected = ru;
      }
      viewY = new Date(selected).getUTCFullYear();
      viewMo = new Date(selected).getUTCMonth();
      setText(els.note, w.notOpenYet
        ? tr('first_delivery', { date: longLabel(w.first) })
        : (w.skippedWeekend
          ? tr('next_delivery', { date: longLabel(w.first) })
          : (w.beforeCutoff ? tr('tomorrow_notice') : tr('cutoff_passed'))));
      setText(els.legend, tr('calendar_legend', { date: longLabel(w.first), weeks: Math.round((D.cycle || D.days.length) / 7) }));
      buildQuick();
      drawMonth();
      renderDay(selected);
    }

    function buildQuick() {
      if (!els.quick) return;
      els.quick.innerHTML = '';
      var picks = [{
        label: w.notOpenYet ? tr('opening_day', { date: dm(w.first) }) : (w.skippedWeekend ? tr('next_delivery_day', { date: dm(w.first) }) : (w.beforeCutoff ? tr('tomorrow') : tr('day_after_tomorrow'))),
        u: w.first
      }];
      var mon = w.first;
      while (dow(mon) !== 1) mon += DAY;
      if (mon !== w.first) picks.push({ label: tr('next_monday'), u: mon });
      if (w.first + 21 * DAY <= w.last) picks.push({ label: tr('three_weeks'), u: w.first + 21 * DAY });
      picks.forEach(function (p) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'upupa-chip';
        b.textContent = p.label;
        b.setAttribute('data-u', String(p.u));
        els.quick.appendChild(b);
      });
    }

    function choose(u) {
      if (!Number.isFinite(u) || u < w.first || u > w.last || isWeekend(u)) return;
      selected = u;
      var d = new Date(u);
      viewY = d.getUTCFullYear();
      viewMo = d.getUTCMonth();
      drawMonth();
      renderDay(u);
      rememberDate(utcToIso(u));
      show(els.msg, false);
      if (dateSwitch) {
        dateSwitch.open = false;
        dateSwitch.querySelector('summary').focus({ preventScroll: true });
      }
    }

    function drawMonth() {
      setText(els.month, MONTHS[viewMo] + ' ' + viewY);
      els.days.innerHTML = '';
      var firstOfMonth = Date.UTC(viewY, viewMo, 1);
      var lead = (new Date(firstOfMonth).getUTCDay() + 6) % 7;
      var n = new Date(Date.UTC(viewY, viewMo + 1, 0)).getUTCDate();
      var i;
      for (i = 0; i < lead; i++) {
        var blank = document.createElement('span');
        blank.className = 'upupa-day is-blank';
        els.days.appendChild(blank);
      }
      for (i = 1; i <= n; i++) {
        var u = Date.UTC(viewY, viewMo, i);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'upupa-day';
        b.textContent = i;
        if (u < w.first || u > w.last || isWeekend(u)) {
          b.disabled = true;
          b.title = isWeekend(u) ? tr('weekend_notice') : (u < w.first ? tr('deadline_passed') : tr('too_far'));
        } else {
          b.setAttribute('aria-pressed', u === selected ? 'true' : 'false');
          b.setAttribute('aria-label', cap(longLabel(u)));
          b.setAttribute('data-u', String(u));
        }
        els.days.appendChild(b);
      }
      if (els.prev) els.prev.disabled = firstOfMonth <= w.first;
      if (els.next) els.next.disabled = Date.UTC(viewY, viewMo, n) >= w.last;
    }

    function dateCard(card, u) { return fillCardDate(card, u); }

    function renderDay(u) {
      setText(els.head, cap(longLabel(u)));
      setText(els.summary, cap(longLabel(u)));
      els.menu.innerHTML = '';
      var row = menuHandles(u);
      var seen = {};
      var buckets = [];
      var total = 0;
      row.forEach(function (h, col) {
        if (!h || seen[h] || !pool[h]) return;
        seen[h] = true;
        total++;
        var label = groups[col] || '';
        var last = buckets[buckets.length - 1];
        if (last && last.label === label) last.cards.push(pool[h]);
        else buckets.push({ label: label, key: categoryKeys[col] || 'group-' + col, cards: [pool[h]] });
      });
      (D.dailyLight || []).forEach(function (h) {
        if (!h || seen[h] || !pool[h]) return;
        seen[h] = true;
        total++;
        var light = buckets.find(function (bk) { return bk.key === 'light'; });
        if (!light) {
          light = { label: tr('light'), key: 'light', cards: [] };
          var later = buckets.findIndex(function (bk) { return bk.key === 'desserts' || bk.key === 'sweets'; });
          buckets.splice(later < 0 ? buckets.length : later, 0, light);
        }
        light.cards.push(pool[h]);
      });
      if (!total) {
        var p = document.createElement('p');
        p.className = 'upupa-empty';
        p.textContent = tr('empty_day');
        els.menu.appendChild(p);
        setText(els.sub, '');
      } else {
        setText(els.sub, quickOrder ? rootEl.getAttribute('data-quick-intro') : tr('basket_intro'));
        buckets.forEach(function (bk, i) {
          if (quickOrder && bk.key !== 'main') return;
          var wrap = document.createElement('div');
          wrap.className = 'upupa-group';
          if (i) wrap.style.marginTop = '18px';
          var lab = document.createElement('div');
          lab.className = 'upupa-glabel';
          lab.textContent = bk.key === 'main' && bk.cards.length > 1 ? tr('mains') : bk.label;
          var grid = document.createElement('div');
          grid.className = 'upupa-grid';
          bk.cards.forEach(function (c) {
            grid.appendChild(cloneCalendarCard(c, u, 'm'));
          });
          wrap.appendChild(lab);
          wrap.appendChild(grid);
          els.menu.appendChild(wrap);
        });
      }
      if (quickOrder) renderCategories(buckets, u);
      rootEl.dispatchEvent(new CustomEvent('upupa:daychange', { bubbles:true, detail:{ iso:utcToIso(u) } }));
      if (els.extras) {
        if (!quickOrder) each(els.extras.querySelectorAll('.upupa-card'), function (c) { dateCard(c, u); });
        show(els.extras, !quickOrder);
      }
    }

    function shift(n) {
      var d = new Date(Date.UTC(viewY, viewMo + n, 1));
      viewY = d.getUTCFullYear();
      viewMo = d.getUTCMonth();
      drawMonth();
    }

    els.days.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[data-u]');
      if (b && !b.disabled) choose(+b.getAttribute('data-u'));
    });
    if (els.quick) {
      els.quick.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('button[data-u]');
        if (b) choose(+b.getAttribute('data-u'));
      });
    }
    if (els.prev) els.prev.addEventListener('click', function () { shift(-1); });
    if (els.next) els.next.addEventListener('click', function () { shift(1); });

    rootEl.upupaRefresh = function (msg) {
      setup();
      if (msg && els.msg) {
        setText(els.msg, msg);
        show(els.msg, true);
        els.msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };
    setup();
  }

  /* ---------- 2b. Ruokalista: valitse ensin ruoka ja näe sen päivät (sections/upupa-ruoat.liquid) ---------- */

  function initDishes(rootEl) {
    rootEl.setAttribute('data-upupa-ready', '');
    var w = orderWindow();
    each(rootEl.querySelectorAll('.upupa-dish[data-handle]'), function (card) {
      if (card.hasAttribute('data-drink-preview')) return;
      var h = card.getAttribute('data-handle');
      var k = kindOf(h);
      var dates = k === 'always' ? [] : availableDates(h, w);
      setText(card.querySelector('[data-el="avail"]'), availabilityText(h, w));
      var unavailable = k !== 'always' && !dates.length;
      card.classList.toggle('is-off', unavailable);
      if (unavailable) {
        card.removeAttribute('href');
        card.setAttribute('aria-disabled', 'true');
        card.setAttribute('tabindex', '-1');
        show(card.querySelector('.cta'), false);
      }
      card.setAttribute('data-next', k === 'always' ? '0' : String(dates.length ? dates[0] : 9e15));
    });
    // Pääruoat järjestetään sen mukaan, mikä on seuraavaksi menulla.
    each(rootEl.querySelectorAll('[data-sort="next"]'), function (grid) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.upupa-dish'));
      cards.sort(function (a, b) { return (+a.getAttribute('data-next')) - (+b.getAttribute('data-next')); });
      cards.forEach(function (c) { grid.appendChild(c); });
    });

    // D-0046: yksi ruokaryhmä kerrallaan (välilehdet).
    var tabs = Array.prototype.slice.call(rootEl.querySelectorAll('[role="tab"][data-cat]'));
    function select(cat, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-cat') === cat;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
        if (on && focus) t.focus();
      });
    }
    rootEl.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[role="tab"][data-cat]');
      if (!t) return;
      select(t.getAttribute('data-cat'));
      try { window.history.replaceState(window.history.state, '', '#ruoat-' + t.getAttribute('data-cat')); } catch (er) {}
    });
    rootEl.addEventListener('keydown', function (e) {
      var t = e.target.closest && e.target.closest('[role="tab"][data-cat]');
      if (!t || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      e.preventDefault();
      var i = tabs.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
      select(tabs[(i + tabs.length) % tabs.length].getAttribute('data-cat'), true);
    });
    var m = /^#ruoat-([a-z0-9-]+)$/.exec(window.location.hash || '');
    var linkedCategory = m && (m[1] === 'juomat' ? 'kylmat-juomat' : m[1]);
    if (linkedCategory && rootEl.querySelector('[role="tab"][data-cat="' + linkedCategory + '"]')) select(linkedCategory);
  }

  /* ---------- 2c. Etusivun "Viikon pääruoat" (sections/upupa-viikon-paaruoat.liquid, D-0049) ---------- */

  function initWeekMains(rootEl) {
    rootEl.setAttribute('data-upupa-ready', '');
    var grid = rootEl.querySelector('[data-el="grid"]');
    var pool = rootEl.querySelector('[data-el="pool"]');
    if (!grid || !pool) return;
    var cards = {};
    each(pool.querySelectorAll('[data-handle]'), function (c) { cards[c.getAttribute('data-handle')] = c; });
    grid.innerHTML = '';
    var shown = 0;
    // Kaksi seuraavaa tilattavaa pääruokaa; jos jokin puuttuu kaupasta, otetaan seuraava.
    nextMains(orderWindow(), 4).forEach(function (r) {
      if (shown >= 2 || !cards[r.h]) return;
      var c = cards[r.h].cloneNode(true);
      setText(c.querySelector('[data-el="days"]'), runText([r.from, r.to]));
      var iso = utcToIso(r.from);
      each(c.querySelectorAll('a[data-upupa-link]'), function (a) { a.setAttribute('href', withDate(a.getAttribute('href'), iso)); });
      grid.appendChild(c);
      shown++;
    });
    show(rootEl, shown > 0);
  }

  /* ---------- 3. Tuotesivun toimituspäivä ---------- */

  function pdpPart(box, n) { return box.querySelector('[data-el="' + n + '"]'); }
  function pdpChecked(box) { return box.querySelector('input[type="radio"]:checked'); }

  function markForm(formId, waiting) {
    var form = formId ? document.getElementById(formId) : null;
    var pf = form && form.closest ? form.closest('product-form-component') : null;
    if (pf) pf.toggleAttribute('data-upupa-wait', !!waiting);
  }

  function syncUnavailablePdp(box) {
    var form = document.getElementById(box.getAttribute('data-form'));
    var unavailable = box.getAttribute('data-state') === 'none';
    var buttons = form ? Array.prototype.slice.call(form.querySelectorAll('[ref="addToCartButton"]')) : [];
    // The sticky purchase control belongs to this product too.
    buttons = buttons.concat(Array.prototype.slice.call(document.querySelectorAll('sticky-add-to-cart [ref="addToCartButton"]')));
    buttons.forEach(function (button) {
      if (unavailable) {
        if (!button.hasAttribute('data-upupa-unavailable')) {
          button.setAttribute('data-upupa-unavailable', button.disabled ? 'disabled' : 'enabled');
          button.setAttribute('title', tr('not_on_menu_sentence'));
        }
        if (!button.disabled) button.disabled = true;
      } else if (button.hasAttribute('data-upupa-unavailable')) {
        if (button.getAttribute('data-upupa-unavailable') === 'enabled') button.disabled = false;
        button.removeAttribute('data-upupa-unavailable');
        button.removeAttribute('title');
      }
    });
  }

  function buildPdp(box) {
    var handle = box.getAttribute('data-handle');
    var formId = box.getAttribute('data-form');
    var list = pdpPart(box, 'dates');
    var more = pdpPart(box, 'more');
    var info = pdpPart(box, 'info');
    var hint = pdpPart(box, 'hint');
    if (!list) return;
    var prev = pdpChecked(box);
    var want = prev ? prev.value : recalledDate();
    var w = orderWindow();
    var kind = kindOf(handle);
    var dates = availableDates(handle, w);
    list.innerHTML = '';
    show(hint, false);
    if (!dates.length) {
      box.setAttribute('data-state', 'none');
      setText(info, tr('not_on_menu_sentence'));
      show(more, false);
      syncPdp(box);
      return;
    }
    box.setAttribute('data-state', kind);
    setText(info, kind === 'always'
      ? tr('pick_any_day')
      : tr('pick_listed_day'));
    var found = false;
    dates.forEach(function (u, i) {
      var iso = utcToIso(u);
      var lab = document.createElement('label');
      lab.className = 'upupa-pdp__chip';
      if (i >= PDP_VISIBLE) lab.hidden = true;
      var inp = document.createElement('input');
      inp.type = 'radio';
      inp.name = 'properties[_pvm]';
      inp.value = iso;
      inp.required = true;
      if (formId) inp.setAttribute('form', formId);
      inp.setAttribute('aria-label', cap(longLabel(u)));
      var boxEl = document.createElement('span');
      boxEl.className = 'box';
      var s1 = document.createElement('span');
      s1.className = 'w';
      s1.textContent = WD_SHORT[dow(u)];
      var s2 = document.createElement('span');
      s2.className = 'd';
      s2.textContent = dm(u);
      boxEl.appendChild(s1);
      boxEl.appendChild(s2);
      lab.appendChild(inp);
      lab.appendChild(boxEl);
      list.appendChild(lab);
      if (want === iso) {
        inp.checked = true;
        lab.hidden = false;
        found = true;
      }
    });
    show(more, dates.length > PDP_VISIBLE);
    if (want && !found) {
      var wu = isoToUtc(want);
      if (wu >= w.first && wu <= w.last) {
        setText(hint, tr('offmenu_hint', { date: longLabel(wu) }));
        show(hint, true);
      }
    }
    syncPdp(box);
  }

  function syncPdp(box) {
    var checked = pdpChecked(box);
    var label = pdpPart(box, 'label');
    var chosen = pdpPart(box, 'chosen');
    if (checked) {
      var u = isoToUtc(checked.value);
      if (label) label.value = propLabel(u);
      setText(chosen, cap(longLabel(u)));
      show(pdpPart(box, 'error'), false);
      box.classList.remove('is-invalid');
    } else {
      if (label) label.value = '';
      setText(chosen, box.getAttribute('data-state') === 'none' ? tr('not_on_menu') : (box.getAttribute('data-date-placeholder') || ''));
    }
    markForm(box.getAttribute('data-form'), !checked);
    syncUnavailablePdp(box);
    refreshSameDay();
  }

  function initPdp(box) {
    box.setAttribute('data-upupa-ready', '');
    buildPdp(box);
  }

  function pdpForForm(form) {
    if (!form || !form.getAttribute('id')) return null;
    var boxes = document.querySelectorAll('[data-upupa-pdp]');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].getAttribute('data-form') === form.getAttribute('id')) return boxes[i];
    }
    return null;
  }

  function pdpBlockReason(box) {
    var checked = pdpChecked(box);
    if (!checked) {
      return box.getAttribute('data-state') === 'none'
        ? tr('not_on_menu_sentence')
        : tr('pick_day_first');
    }
    var p = dateProblem(box.getAttribute('data-handle'), checked.value);
    if (!p) return '';
    checked.checked = false;
    buildPdp(box);
    return p === 'past'
      ? tr('expired_date')
      : tr('pick_day_again');
  }

  function pdpShowError(box, msg) {
    var picker = pdpPart(box, 'picker');
    if (picker) picker.open = true;
    var err = pdpPart(box, 'error');
    setText(err, msg);
    show(err, true);
    box.classList.add('is-invalid');
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var first = box.querySelector('.upupa-pdp__chip:not([hidden]) input[type="radio"]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- 3b. Menulla-merkki ja "Samana päivänä menulla" (D-0049) ---------- */

  function initBadge(el) {
    el.setAttribute('data-upupa-ready', '');
    var h = el.getAttribute('data-handle');
    var k = kindOf(h);
    var r = k === 'always' ? null : firstRun(availableDates(h));
    el.classList.toggle('is-off', k !== 'always' && !r);
    setText(el, k === 'always' ? tr('order_every_day') : (r ? tr('on_menu_badge') + runText(r) : tr('not_on_menu')));
    show(el, true);
  }

  function cloneSameDayCard(card, u, suffix) {
    var clone = card.cloneNode(true);
    var ids = Object.create(null);
    each(clone.querySelectorAll('[id]'), function (el) {
      var oldId = el.getAttribute('id');
      var newId = oldId + '-' + (suffix || 'same-day');
      el.setAttribute('id', newId);
      ids[oldId] = newId;
    });
    each(clone.querySelectorAll('[for], [form], [aria-labelledby], [aria-describedby], [aria-controls]'), function (el) {
      ['for', 'form', 'aria-labelledby', 'aria-describedby', 'aria-controls'].forEach(function (attr) {
        var value = el.getAttribute(attr);
        if (value) el.setAttribute(attr, value.split(/\s+/).map(function (id) { return ids[id] || id; }).join(' '));
      });
    });
    return u === null ? clone : fillCardDate(clone, u);
  }

  function renderPairings(rootEl, u) {
    var menu = rootEl.querySelector('[data-el="menu"]');
    var sub = rootEl.querySelector('[data-el="sub"]');
    var pool = rootEl._upupaPool || {};
    if (!menu) return;
    menu.innerHTML = '';
    rootEl.getAttribute('data-upupa-curated').split(',').forEach(function (handle) {
      if (!pool[handle] || (u !== null && !availableOn(handle, u))) return;
      var card = cloneSameDayCard(pool[handle], u, rootEl.id);
      each(card.querySelectorAll('button[name="add"]'), function (button) { button.disabled = u === null; });
      menu.appendChild(card);
    });
    setText(sub, u === null ? rootEl.getAttribute('data-pending-label') : cap(longLabel(u)) + ' · ' + rootEl.getAttribute('data-ready-label'));
    show(rootEl, true);
  }

  function renderSameDay(rootEl) {
    var pool = rootEl._upupaPool || {};
    var menu = rootEl.querySelector('[data-el="menu"]');
    var sub = rootEl.querySelector('[data-el="sub"]');
    var allWrap = rootEl.querySelector('[data-el="all-wrap"]');
    var all = rootEl.querySelector('[data-el="all"]');
    var own = rootEl.getAttribute('data-handle');
    var box = document.querySelector('[data-upupa-pdp]');
    if (!menu) return;
    menu.innerHTML = '';
    show(allWrap, false);
    var checked = box ? pdpChecked(box) : null;
    var u = checked && !dateProblem(own, checked.value) ? isoToUtc(checked.value) : null;
    if (rootEl.hasAttribute('data-upupa-curated')) {
      renderPairings(rootEl, u);
      return;
    }
    if (u === null) {
      setText(sub, tr('same_day_note'));
      show(rootEl, !!box && availableDates(own).length > 0);
      return;
    }
    var menuCards = [];
    var seen = {};
    menuHandles(u).forEach(function (h) {
      if (!h || h === own || seen[h] || !pool[h]) return;
      seen[h] = true;
      menuCards.push(pool[h]);
    });
    var queues = [menuCards];
    ['salaatit', 'juomat', 'lisukkeet'].forEach(function (category) {
      var cards = [];
      (rootEl._upupaExtras[category] || []).forEach(function (handle) {
        if (handle === own || seen[handle] || !pool[handle] || (!availableOn(handle, u) && !pool[handle].hasAttribute('data-drink-preview'))) return;
        seen[handle] = true;
        cards.push(pool[handle]);
      });
      if (cards.length) queues.push(cards);
    });
    var ordered = [];
    var next = true;
    for (var index = 0; next; index++) {
      next = false;
      queues.forEach(function (cards) {
        if (cards[index]) {
          ordered.push(cards[index]);
          next = true;
        }
      });
    }
    if (!ordered.length) { show(rootEl, false); return; }
    setText(sub, cap(longLabel(u)) + tr('same_delivery_suffix'));
    ordered.forEach(function (card) {
      menu.appendChild(cloneSameDayCard(card, u));
    });
    if (all) all.setAttribute('href', withDate(routeRoot(), utcToIso(u)) + '#viikon-menu');
    show(allWrap, !!all);
    show(rootEl, true);
  }

  function initSameDay(rootEl) {
    rootEl.setAttribute('data-upupa-ready', '');
    var pool = {};
    var extras = { salaatit: [], juomat: [], lisukkeet: [] };
    each(rootEl.querySelectorAll('[data-el="pool"] .upupa-card[data-handle]'), function (c) {
      var h = c.getAttribute('data-handle');
      if (h && !pool[h]) {
        pool[h] = c;
        var group = c.closest('[data-sp-category]');
        var category = group && group.getAttribute('data-sp-category');
        if (category && extras[category]) extras[category].push(h);
      }
    });
    rootEl._upupaPool = pool;
    rootEl._upupaExtras = extras;
    renderSameDay(rootEl);
  }

  function refreshSameDay() {
    each(document.querySelectorAll('[data-upupa-sp][data-upupa-ready]'), renderSameDay);
  }

  /* ---------- Lisäysten vartija: ei ostoskoriin ilman toimituspäivää ---------- */

  function isAddForm(form) {
    return !!(form && form.getAttribute && /\/cart\/add/.test(form.getAttribute('action') || ''));
  }

  function checkAddForm(form) {
    if (!isAddForm(form)) return null;
    var box = pdpForForm(form);
    if (box) {
      var reason = pdpBlockReason(box);
      return reason ? { box: box, msg: reason } : null;
    }
    var isoEl = form.querySelector('[data-upupa-iso]');
    if (!isoEl) {
      // Lomake ilman päivävalintaa (esim. pikalisäys): ohjataan tuotesivulle valitsemaan päivä.
      // Jos ollaan jo tuotteen sivulla ilman valitsinta, ostoskorin tarkistus hoitaa päivän.
      var pf = form.closest('product-form-component');
      var card = form.closest('product-card');
      var link = card && card.querySelector('a[href*="/products/"]');
      var target = (pf && pf.getAttribute('data-product-url')) || (link && link.getAttribute('href')) || '';
      var samePage = false;
      try { samePage = new URL(target, window.location.origin).pathname === window.location.pathname; } catch (e) {}
      return target && !samePage ? { redirect: target } : null;
    }
    var menuCard = form.closest('.upupa-card');
    var handle = menuCard && menuCard.getAttribute('data-handle');
    var slotEl = form.querySelector('[data-package-slot]');
    var p = mealPackageProblem(handle, isoEl.value, slotEl && slotEl.value);
    if (!p) return null;
    var pastMsg = tr('expired_date');
    // "Samana päivänä menulla" -kortti: päivä valitaan tuotesivun valitsimesta.
    if (form.closest('[data-upupa-sp]')) {
      var mainBox = document.querySelector('[data-upupa-pdp]');
      if (!mainBox) return { msg: '' };
      var chk = pdpChecked(mainBox);
      if (chk && dateProblem(mainBox.getAttribute('data-handle'), chk.value)) {
        chk.checked = false;
        buildPdp(mainBox);
      }
      return { box: mainBox, msg: p === 'past' ? pastMsg : tr('pick_day_again') };
    }
    return {
      cal: form.closest('[data-upupa-cal]'),
      msg: p === 'past' ? pastMsg : tr('pick_calendar')
    };
  }

  function reportAdd(res) {
    if (res.box) pdpShowError(res.box, res.msg);
    else if (res.cal && res.cal.upupaRefresh) res.cal.upupaRefresh(res.msg);
    else if (res.redirect) window.location.href = res.redirect;
  }

  /* ---------- 4. Ostoskori ---------- */

  var saving = Promise.resolve();
  var gateBusy = false;
  var checkoutMinimumMessage = false;
  var REASONS = {
    missing: tr('date_missing'),
    past: tr('date_past'),
    far: tr('date_far'),
    offmenu: tr('date_offmenu'),
    weekend: tr('weekend_notice'),
    week: tr('party_week')
  };

  var unsavedAttrs = {};

  function confirmAttrs(attrs) {
    Object.keys(attrs).forEach(function (key) {
      if (unsavedAttrs[key] === attrs[key]) delete unsavedAttrs[key];
    });
  }

  function flushUnsavedAttrs() {
    var attrs = {};
    Object.keys(unsavedAttrs).forEach(function (key) { attrs[key] = unsavedAttrs[key]; });
    if (!Object.keys(attrs).length) return Promise.resolve();
    return postJSON('cart/update.js', { attributes: attrs }).then(function () { confirmAttrs(attrs); });
  }

  function saveAttrs(attrs) {
    Object.keys(attrs).forEach(function (key) { unsavedAttrs[key] = attrs[key]; });
    saving = saving.then(function () { return postJSON('cart/update.js', { attributes: attrs }); })
      .then(function () { confirmAttrs(attrs); })
      .catch(function () { cartMessage(tr('connection_error')); });
    return saving;
  }

  function staffDomItem(el) {
    return { variant_id: el.getAttribute('data-variant-id'), properties: { _upupa_coffee_variant: el.getAttribute('data-coffee-variant'), _upupa_meal_dessert: el.getAttribute('data-meal-dessert') } };
  }

  function fillFix(sel) {
    if (sel.getAttribute('data-party') === 'true') {
      sel.min = utcToIso(partyWindow().first);
      return;
    }
    if (sel.getAttribute('data-filled') === '1') return;
    sel.setAttribute('data-filled', '1');
    var dates = availableDates(sel.getAttribute('data-handle')).filter(function (u) { return !(sel.getAttribute('data-handle') === 'make-it-a-meal' ? mealOfferProblem(staffDomItem(sel), utcToIso(u)) : sel.getAttribute('data-handle') === 'henkilostoateria' ? staffPackageProblem(staffDomItem(sel), utcToIso(u)) : mealPackageProblem(sel.getAttribute('data-handle'), utcToIso(u), sel.getAttribute('data-package-slot'))); });
    while (sel.options.length > 1) sel.remove(1);
    dates.forEach(function (u) {
      var o = document.createElement('option');
      o.value = utcToIso(u);
      o.textContent = cap(longLabel(u));
      sel.appendChild(o);
    });
    if (!dates.length && sel.options[0]) {
      sel.options[0].textContent = tr('no_dates');
      sel.disabled = true;
    }
  }

  function markItem(li, type) {
    var r = li.querySelector('[data-upupa-reason]');
    setText(r, REASONS[type] || REASONS.missing);
    show(r, true);
    var sel = li.querySelector('[data-upupa-fix]');
    if (sel) {
      fillFix(sel);
      show(sel, true);
    }
  }

  function clearItem(li) {
    show(li.querySelector('[data-upupa-reason]'), false);
    show(li.querySelector('[data-upupa-fix]'), false);
  }

  function scanCart() {
    var items = document.querySelectorAll('[data-upupa-item]');
    if (!items.length) return;
    var w = orderWindow();
    var problems = 0;
    each(items, function (li) {
      var p = li.getAttribute('data-handle') === 'make-it-a-meal' ? mealOfferProblem(staffDomItem(li), li.getAttribute('data-iso'), w) : li.getAttribute('data-handle') === 'henkilostoateria' ? staffPackageProblem(staffDomItem(li), li.getAttribute('data-iso'), w) : li.getAttribute('data-party') === 'true' ? celebrationDateProblem(li.getAttribute('data-iso'), li.getAttribute('data-handle')) : mealPackageProblem(li.getAttribute('data-handle'), li.getAttribute('data-iso'), li.getAttribute('data-package-slot'), w);
      if (p) { markItem(li, p); problems++; }
      else clearItem(li);
    });
    var allTimes = true;
    each(document.querySelectorAll('select[data-upupa-time]'), function (s) { if (!s.value) allTimes = false; });
    var benefitBox = document.querySelector('[data-upupa-benefit-total]');
    if (checkoutMinimumMessage && benefitBox && Number(benefitBox.getAttribute('data-upupa-benefit-total')) >= 2000) checkoutMinimumMessage = false;
    if (!checkoutMinimumMessage && !problems && allTimes && !Object.keys(unsavedAttrs).length) cartMessage('');
    each(document.querySelectorAll('[data-upupa-cart-delivery]'), function (disclosure) {
      var needsCheck = !!disclosure.querySelector('[data-upupa-reason]:not([hidden]), .is-invalid');
      show(disclosure.querySelector('[data-upupa-delivery-state]'), needsCheck);
    });
  }

  function saveTime(sel) {
    var iso = sel.getAttribute('data-upupa-time');
    var attrs = {};
    attrs[ATTR_PREFIX + iso] = sel.value;
    each(document.querySelectorAll('select[data-upupa-time="' + cssEsc(iso) + '"]'), function (s) {
      if (s !== sel && s.value !== sel.value) s.value = sel.value;
    });
    var g = sel.closest('[data-upupa-group]');
    if (g && sel.value) {
      g.classList.remove('is-invalid');
      show(g.querySelector('[data-upupa-group-error]'), false);
    }
    saveAttrs(attrs).then(scanCart);
  }

  function fixLine(sel) {
    var iso = sel.value;
    if (!ISO_RE.test(iso)) return;
    var key = sel.getAttribute('data-key');
    sel.disabled = true;
    saving = saving.then(getCart).then(function (cart) {
      var line = (cart.items || []).filter(function (it) { return it.key === key; })[0];
      if (!line) return null;
      if (line.handle === 'make-it-a-meal' ? mealOfferProblem(line, iso) : line.handle === 'henkilostoateria' ? staffPackageProblem(line, iso) : partyItem(line) ? celebrationDateProblem(iso, line.handle) : mealPackageProblem(line.handle, iso, (line.properties || {})._upupa_package_slot)) throw new Error('invalid delivery date');
      var props = {};
      Object.keys(line.properties || {}).forEach(function (k) { props[k] = line.properties[k]; });
      ['Toimituspäivä', 'Delivery date', 'Leveransdatum'].forEach(function (label) { delete props[label]; });
      props[tr('delivery_date_label') || 'Toimituspäivä'] = propLabel(isoToUtc(iso));
      props._pvm = iso;
      return postJSON('cart/change.js', { id: key, quantity: line.quantity, properties: props });
    }).then(function () {
      window.location.reload();
    }, function () {
      sel.disabled = false;
      cartMessage(tr('connection_error'));
    });
  }

  function cartMessage(msg) {
    each(document.querySelectorAll('[data-upupa-delivery] [data-upupa-error]'), function (err) {
      setText(err, msg);
      show(err, !!msg);
      var disclosure = err.closest('[data-upupa-cart-delivery]');
      if (msg && disclosure) disclosure.open = true;
    });
  }

  function showCartProblems(res) {
    var firstEl = null;
    var located = 0;
    each(document.querySelectorAll('[data-upupa-delivery]'), function (box) {
      each(box.querySelectorAll('[data-upupa-group]'), function (g) {
        var iso = g.getAttribute('data-upupa-group');
        var bad = !!iso && res.missingTime.indexOf(iso) > -1;
        g.classList.toggle('is-invalid', bad);
        var ge = g.querySelector('[data-upupa-group-error]');
        setText(ge, bad ? tr('pick_time') : '');
        show(ge, bad);
        if (bad) { located++; if (!firstEl) firstEl = g; }
      });
      res.itemProblems.forEach(function (pr) {
        var li = box.querySelector('[data-upupa-item][data-key="' + cssEsc(pr.key) + '"]');
        if (li) {
          markItem(li, pr.type);
          located++;
          if (!firstEl) firstEl = li;
        }
      });
    });
    if (res.partyProblem) {
      checkoutMinimumMessage = true;
      cartMessage(partyMessage(res.partyProblem));
      return;
    }
    cartMessage(tr('check_delivery'));
    if (firstEl) {
      firstEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var focusable = firstEl.querySelector('select:not([hidden]), input:not([hidden])');
      if (focusable) { try { focusable.focus({ preventScroll: true }); } catch (e) {} }
    } else if (!located) {
      // Näkymä on vanhentunut (ostoskoria muutettu muualla): päivitä kerran.
      var last = 0;
      try { last = +window.sessionStorage.getItem('upupa_reload') || 0; } catch (e) {}
      if (Date.now() - last > 10000) {
        try { window.sessionStorage.setItem('upupa_reload', String(Date.now())); } catch (e) {}
        window.location.reload();
      }
    }
  }

  function gate(btn) {
    if (gateBusy) return;
    checkoutMinimumMessage = false;
    gateBusy = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    var release = function () {
      gateBusy = false;
      if (btn) btn.removeAttribute('aria-busy');
    };
    saving.then(flushUnsavedAttrs).then(getCart).then(syncPikkujouluBenefit).then(function (cart) {
      if (Object.keys(unsavedAttrs).length) throw new Error('Delivery time has not been saved');
      var res = auditCart(cart);
      if (!res.ok) {
        release();
        if (!(cart.items || []).length) return;
        showCartProblems(res);
        return;
      }
      cartMessage('');
      var go = function () { window.location.href = routeRoot() + 'checkout'; };
      if (Object.keys(res.cleanup).length) {
        return postJSON('cart/update.js', { attributes: res.cleanup }).then(go);
      } else {
        go();
      }
    }).catch(function () {
      release();
      cartMessage(tr('connection_error'));
    });
  }

  /* ---------- Tapahtumat ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // D-0049: "Ylös" – sivun alkuun; kohdistus sivun ensimmäiseen linkkiin.
    var up = t.closest('[data-upupa-ylos]');
    if (up) {
      var reduce = false;
      try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (er) {}
      try { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); } catch (er) { window.scrollTo(0, 0); }
      var skip = document.querySelector('.skip-to-content-link, a[href="#MainContent"]');
      if (skip) { try { skip.focus({ preventScroll: true }); } catch (er) {} }
      return;
    }

    // D-0046: "Takaisin" – edelliselle sivulle, jos se oli kaupan sisällä; muuten linkki vie etusivulle.
    var back = t.closest('[data-upupa-back]');
    if (back) {
      var same = false;
      try { same = !!document.referrer && new URL(document.referrer).origin === window.location.origin; } catch (er) {}
      if (same && window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
      return;
    }

    var co = t.closest('button[name="checkout"], .cart__checkout-button');
    if (co) {
      e.preventDefault();
      e.stopImmediatePropagation();
      gate(co);
      return;
    }

    var more = t.closest('[data-upupa-pdp] [data-el="more"]');
    if (more) {
      var pbox = more.closest('[data-upupa-pdp]');
      each(pbox.querySelectorAll('.upupa-pdp__chip[hidden]'), function (l) { l.hidden = false; });
      show(more, false);
      return;
    }

    var btn = t.closest('button[name="add"], [ref="addToCartButton"]');
    if (!btn) return;
    var form = btn.form || null;
    if (!form && btn.closest('sticky-add-to-cart')) {
      var mainBox = document.querySelector('[data-upupa-pdp]');
      form = mainBox ? document.getElementById(mainBox.getAttribute('data-form')) : null;
    }
    var res = checkAddForm(form);
    if (res) {
      e.preventDefault();
      e.stopImmediatePropagation();
      reportAdd(res);
    }
  }, true);

  // Native validation must reveal required radios before focusing a closed disclosure.
  document.addEventListener('invalid', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-upupa-pdp] input[type="radio"]')) return;
    e.preventDefault();
    var box = input.closest('[data-upupa-pdp]');
    var picker = pdpPart(box, 'picker');
    if (!box.classList.contains('is-invalid') || (picker && !picker.open)) {
      pdpShowError(box, box.getAttribute('data-date-placeholder') || tr('pick_day_first'));
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.id === 'cart-form') {
      var sub = e.submitter;
      if (!sub || sub.name === 'checkout') {
        e.preventDefault();
        e.stopImmediatePropagation();
        gate(document.querySelector('button[name="checkout"]'));
      }
      return;
    }
    var res = checkAddForm(form);
    if (res) {
      e.preventDefault();
      e.stopImmediatePropagation();
      reportAdd(res);
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('select[data-upupa-card-variant]')) {
      var card = t.closest('.upupa-card');
      var option = t.selectedOptions[0];
      var idInput = card && card.querySelector('input[name="id"]');
      if (idInput && option && !option.disabled) {
        idInput.value = option.value;
        setText(card.querySelector('.p'), option.getAttribute('data-money'));
      }
    }
    else if (t.matches('select[data-upupa-time]')) saveTime(t);
    else if (t.matches('[data-upupa-fix]')) fixLine(t);
    else if (t.matches('[data-upupa-pdp] input[type="radio"]')) {
      var box = t.closest('[data-upupa-pdp]');
      syncPdp(box);
      rememberDate(t.value);
    }
  });

  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-upupa-fix]')) fillFix(t);
  });

  // D-0049: korttien kuvanvaihto (pisteet seuraavat pyyhkäisyä) ja "Ylös"-painikkeen näkyvyys.
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || el.nodeType !== 1 || !el.hasAttribute('data-upupa-strip')) return;
    var i = el.clientWidth ? Math.round(el.scrollLeft / el.clientWidth) : 0;
    each(el.parentNode ? el.parentNode.querySelectorAll('.upupa-strip__dots i') : [], function (d, j) {
      d.classList.toggle('on', j === i);
    });
  }, true);
  var upBtn = null;
  function toggleUp() {
    if (!upBtn || !upBtn.isConnected) upBtn = document.querySelector('[data-upupa-ylos]');
    if (upBtn) show(upBtn, (window.pageYOffset || document.documentElement.scrollTop || 0) > 700);
  }
  window.addEventListener('scroll', toggleUp, { passive: true });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    gateBusy = false;
    each(document.querySelectorAll('.cart__checkout-button[aria-busy], button[name="checkout"][aria-busy]'), function (b) {
      b.removeAttribute('aria-busy');
    });
  });

  var pending = false;
  function scan() {
    pending = false;
    each(document.querySelectorAll('[data-upupa-cal]:not([data-upupa-ready])'), initCalendar);
    each(document.querySelectorAll('[data-upupa-dishes]:not([data-upupa-ready])'), initDishes);
    each(document.querySelectorAll('[data-upupa-pdp]:not([data-upupa-ready])'), initPdp);
    each(document.querySelectorAll('[data-upupa-pdp][data-upupa-ready]'), syncUnavailablePdp);
    each(document.querySelectorAll('[data-upupa-vp]:not([data-upupa-ready])'), initWeekMains);
    each(document.querySelectorAll('[data-upupa-badge]:not([data-upupa-ready])'), initBadge);
    each(document.querySelectorAll('[data-upupa-sp]:not([data-upupa-ready])'), initSameDay);
    scanCart();
    toggleUp();
  }
  function schedule() {
    if (pending) return;
    pending = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(scan);
    else setTimeout(scan, 16);
  }
  scan();
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();




